import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clients-section',
  templateUrl: './clients-section.component.html',
  styleUrls: ['./clients-section.component.css']
})
export class ClientsSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
